import React, { useState } from "react";

import { useAppSelector } from "../../../app/store";

import {
  EntityType,
  RelatedAs,
} from "../../../api/stakeholder_relationships";

import {
  getStakeholderById,
  getStakeholderRelationshipsByEntity,
} from "../logic/stakeholderSlice";

import StakeholderItem from "./StakeholderItem";
import AddStakeholderButton from "./AddStakeholderButton";
import AddStakeholderModal from "./AddStakeholderModal";
import { shallowEqual } from "react-redux";

const GUARANTOR_RELATIONSHIPS = [RelatedAs.GUARANTOR];

export interface GuarantorsSectionProps {
  accountNumber: string;
  onGuarantorClick: (stakeholderId: string) => void;
}

const GuarantorsSection: React.FC<GuarantorsSectionProps> = ({
  accountNumber,
  onGuarantorClick,
}) => {
  const [showAddBorrowerModal, setShowAddBorrowerModal] =
    useState(false);

  const relationships = useAppSelector((state) =>
    getStakeholderRelationshipsByEntity(
      state,
      EntityType.LOAN_ACCOUNT,
      accountNumber,
      GUARANTOR_RELATIONSHIPS,
    ),
  );

  const guarantors = useAppSelector(
    (state) =>
      relationships
        .map((relationship) =>
          getStakeholderById(
            state,
            relationship.stakeholder_id,
          ),
        )
        .filter(Boolean),
    shallowEqual,
  );

  const handleAddGuarantor = () => {
    setShowAddBorrowerModal(true);
  };

  const handleCloseAddBorrowerModal = () => {
    setShowAddBorrowerModal(false);
  };

  return (
    <>
      <div className="flex w-full flex-col gap-3">
        <div className="flex items-center">
          <span className="text-sm font-medium leading-5 text-[#0A0A0A]">
            Guarantors
          </span>
        </div>

        <div className="flex w-full flex-wrap items-center gap-2">
          {guarantors.map((guarantor) => {
            if (!guarantor) return null;

            return (
              <div
                key={guarantor.stakeholder_id}
                className="w-[278px] shrink-0"
              >
                <StakeholderItem
                  name={guarantor.name}
                  relatedAs={RelatedAs.GUARANTOR}
                  onClick={() =>
                    onGuarantorClick(
                      guarantor.stakeholder_id,
                    )
                  }
                  className="w-full"
                />
              </div>
            );
          })}

          <AddStakeholderButton
            label="Add"
            onClick={handleAddGuarantor}
          />
        </div>
      </div>

      {showAddBorrowerModal && (
        <AddStakeholderModal
          accountNumber={accountNumber}
          relatedAs={RelatedAs.GUARANTOR}
          onClose={handleCloseAddBorrowerModal}
        />
      )}
    </>
  );
};

export default GuarantorsSection;